export const campaignStickyButton = {
	init: function() {
		this.buttonScrollContainer = document.querySelector('.form-link__link-scroll-container');
		this.buttonWrapper = this.buttonScrollContainer.querySelector('.form-link__background');
		this.button = this.buttonScrollContainer.querySelector('.form-link__button.jsScrollTo');
		this.formContainer = document.querySelector('.diagnostic-form');

		this.assignEventListeners()
	},

	assignEventListeners: function() {
		window.addEventListener('scroll', ()=> {
			const buttonFromTop = this.buttonScrollContainer.getBoundingClientRect().top;
			const fromPosition = this.formContainer.getBoundingClientRect().top;
			const fromPositionBt = this.formContainer.getBoundingClientRect().bottom;
			
			if (buttonFromTop < 0 || fromPositionBt < 0) {
				this.buttonWrapper.classList.add('form-link__background--fixed');
				this.buttonScrollContainer.style.height = this.button.offsetHeight + 'px';
			} 
			if (fromPosition < 0 + this.button.offsetHeight && fromPositionBt > 0 || buttonFromTop > 0) {
				this.buttonWrapper.classList.remove('form-link__background--fixed');
			}
		});
	}
}
